import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of, throwError } from 'rxjs';
import { ApiUrlHelper, UrlQueryParams } from '../api-url-helper';
import { VideoTransFormer } from '../../_transformers/video.transformer';

import { HttpHeaders } from '@angular/common/http';
import { HttpClientHelper } from '../http-helper';
// import { isFulfilled } from 'q';
import { environment } from '../../../environments/environment';
import { StorageService } from '../../storageprovider';
import { map, tap, flatMap, delay, shareReplay } from 'rxjs/operators';
@Injectable()
export class PlayHistoryService {
    isAdult = environment.cinema === 2;
    private _playHistoryStatusService = new BehaviorSubject<any>({});
    playHistoryStatusSource$ = this._playHistoryStatusService.asObservable();

    constructor(
        private _storage: StorageService,

        private _apiUrlHelper?: ApiUrlHelper,
        private _videoTransFormer?: VideoTransFormer,
        private _httpClientHelper?: HttpClientHelper,
    ) { }

    changePlayHistoryStatus(value) {
        this._playHistoryStatusService.next(value);
    }

    getRemoteToken(user): Observable<any> {
        return of({
            
        })
        // const apiURL = this._apiUrlHelper.urlBuilder('user-token', {
        // });
        // return this._httpClientHelper.get(apiURL)
        //     .pipe(map(res => {
        //         return res[0];
        //     }));
    }
    delaySomeMillsecond(millsec): Date {
        var dateObj = Date.now();
        dateObj += millsec;
        return new Date(dateObj);

    }
    public lastKey = "";
    private lastResult = null;
    public getRemotePlayHistory(user, page = 1, pageSize = 10, orderBy, Desc, cid, isFinished, filter): Observable<any> {
        let token;
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        return this.getRemoteToken(user)
            .pipe(tap(t => token = t))
            .pipe(flatMap(t => {
                // const resultUrl = new URL('http://www.google.com' + t);
                var apiURL = this._apiUrlHelper.urlBuilder('watch-history', {});

                const body = {}; // new URLSearchParams();
                if (this.isAdult) {
                    body['cinema'] = '2';
                }
              
                body['pageSize'] = pageSize.toString();
                if (orderBy) {
                    body['orderBy'] = orderBy.toString();
                    // body.set('orderBy', orderBy.toString());
                }
        
                body['pageIndex'] = page.toString();
               
                if (Desc) {
                    body['desc'] = '1';
                } else {
                    body['desc'] = '0';
                }
                if (cid) {
                  
                    body['cid'] = cid;
                }
                if (filter) {
                    body['tags'] = filter;
                }
                if (isFinished || isFinished === 0) {
                    body['finishStatus'] = isFinished;
                }
                var queryString = ApiUrlHelper.toQueryString(body);
                var key = `playListKey_`+queryString;
                if(this.lastKey != key)
                {
                    this.lastKey = key;
                    this.lastResult =  this._httpClientHelper.post(apiURL, queryString, httpOptions)
                    .pipe(map(list=> {
                        if(list.length >0)
                        {
                            var item = list[0];
                            const total = item.recordCount;
                            const items = item.list;
                            return {
                                total,
                                items: !items ? [] : items.map(item => {
                                    return this._videoTransFormer.transformFromWatchHistoryList(item);
                                })
                            };
                        }
                        return {
                            total:0,
                            items:[]
                        }
                       
                    })).pipe(shareReplay({
                        bufferSize:1,
                        refCount:true
                      }));
                    
                }
              
                return this.lastResult;

            }));
    }

    removeRemotePlayHistory(user, items, cid) {
        let token;
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        return this.getRemoteToken(user)
            .pipe(tap(t => token = t))
            .pipe(flatMap(t => {
                // const resultUrl = new URL('http://www.google.com' + t);
                const apiURL = this._apiUrlHelper.urlBuilder('remove-watch-history', {});

                const body = new UrlQueryParams();
                if (this.isAdult) {
                    body.set('cid', '2');
                } else if (cid) {
                    body.set("cid", cid)
                }
                items.map(item => {
                    body.append('idlist[]', item.toString());
                });
                return this._httpClientHelper.post(apiURL, body.toString(), httpOptions)
                    .pipe(map(l => {
                        if(l.length>0)
                        {
                            this.changePlayHistoryStatus(true);
                            return l[0];
                        }
                        this.lastKey = null;
                        return false;
                    
                    }));
            }));
    }

    clearRemotePlayHistory(user, cid?) {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        const apiURL = this._apiUrlHelper.urlBuilder('clear-watch-history', {});
        const body = new UrlQueryParams();
       // body.set('uid', user.id);
        if (cid == 7 || cid == 8) {
            body.set('cid', cid);
        }
        if (this.isAdult) {
            body.set('cid', '2');
        }
        if (cid == 3) {
            body.set('cid', '3');
        }
        return this._httpClientHelper.post(apiURL, body.toString(), httpOptions)
            .pipe(map(l => {
                this.lastKey = null;
                if(!!l && l.length>0)
                return l[0];
                return false;
            }));
    }

    getLocalPlayHistory() {
        const strHistroy = this._storage.GetItem('history');
        const history = strHistroy ? JSON.parse(strHistroy) : [];
        //console.log(history);

        return history;
    }

    getLocalPlayHistoryById(videoId) {
        const history = this.getLocalPlayHistory();
        const result = history.filter(item => item.vid === videoId);
        if (result.length > 0) {
            return result[0];
        }
        return null;
    }

    pushLocalPlayHistory(rec) {
        this.removeLocalPlayHistory(rec.vid);
        const history = this.getLocalPlayHistory();
        history.push(rec);
        while (history.length > 10) {
            history.shift();
        }
        this._storage.SetItem('history', JSON.stringify(history));
    }

    removeLocalPlayHistory(videoId) {
        let history = this.getLocalPlayHistory();
        history = history ? history.filter(item => item.vid !== videoId) : [];
        this._storage.SetItem('history', JSON.stringify(history));
    }

    clearLocalPlayHistory() {
        this._storage.RemoveItem('history');
        return [];
    }

    public getAlbumRecords(user, page = 1, pageSize = 10, orderBy, cid, filter): Observable<any> {
        let token;
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        return this.getRemoteToken(user)
            .pipe(tap(t => token = t))
            .pipe(flatMap(t => {
                var apiURL = this._apiUrlHelper.urlBuilder('ablum-record-list', {});
                const body = {};
                body['pageSize'] = pageSize.toString();
                if (orderBy) {
                    body['orderBy'] = orderBy.toString();
                }
                body['pageIndex'] = page.toString();
                if (cid) {
                    body['cid'] = cid;
                }
                if (filter) {
                    body['tags'] = filter;
                }
                return this._httpClientHelper.post(apiURL, ApiUrlHelper.toQueryString(body), httpOptions)
                    .pipe(delay(200))
                    .pipe(map(list=> {
                        if(list.length >0){
                            var item = list[0];
                            const total = item.recordCount;
                            const items = item.list;
                            return {
                                total,
                                items: !items ? [] : items.map(item => {
                                    return item;
                                })
                            };
                        }
                        return {
                            total:0,
                            items:[]
                        }
                    }));
            }));
    }

    clearHotAlbumCache() {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        const apiURL = this._apiUrlHelper.urlBuilder('clear-hot-album-cache', {});
        return this._httpClientHelper.post(apiURL, '', httpOptions)
            .pipe(map(res => {
                return res;
            }));
    }

}
